import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Container, CircularProgress } from "@mui/material";
import IndexCard from "../../../shared/IndexCard";
import { Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const JobListPage = ({ csrfToken }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const openJobs = jobs;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchJobs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch("/jobs.json", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!res.ok) {
        const text = await res.text();
        console.error("jobs.json error", res.status, text);
        if (res.status === 403) {
          setJobs([]);
        } else {
          setJobs([]);
        }
        return;
      }
      const data = await res.json();
      setJobs(data);
    } catch (err) {
      console.error("fetchJobs failed:", err);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchJobs();
    const onFocus = () => fetchJobs();
    const onVisibility = () => document.visibilityState === "visible" && fetchJobs();
    const onPageShow = (e) => e.persisted && fetchJobs();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [fetchJobs])
  
  const handleMarkedRead = useCallback((jobId) => {
    setJobs((prev) =>
      prev.map((j) => (j.id === jobId ? {...j, read_flag: true} : j))
    );
  }, []);

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 4, mb: 10 }}>
        {/* 左：戻るリンク */}
        <Typography
          mb={3}
          sx={{
            fontSize: "1.25rem",
            fontWeight: "bold",
            textDecoration: "none",
            color: "inherit",
            cursor: "pointer",
            "&:hover": {
              opacity: 0.7,
            },
          }}
          onClick={() => (window.location.href = "/user_job_request")}
        >
          ＜ 戻る
        </Typography>

        <Typography variant="h5" fontWeight="bold" mb={1}>
          求人
        </Typography>
        <Typography
          color="text.secondary"
          variant={isMobile ? "caption" : "body2"}
          sx={
            isMobile
              ? { fontSize: "0.82rem", mb: 3, display: "block" }
              : { mb: 3, display: "block" }
          }
        >
          詳細を聞きたいボタンで企業に問い合わせできます
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : openJobs.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            現在、公開中の求人はありません。
          </Typography>
        ) : (
          openJobs.map((job) => (
            <IndexCard
              key={job.id}
              item={job}
              type="job"
              component={Link}
              to={`/jobs/${job.id}`} // ユーザー向け詳細ページへ
              csrfToken={csrfToken}
              onMarkedRead={handleMarkedRead}
            />
          ))
        )}
      </Container>
    </>
  );
};

export default JobListPage;
